// @flow
import AmexIcon from './assets/amex'
import DinnerIcon from './assets/dinner'
import DiscoverIcon from './assets/discover'
import JCBIcon from './assets/jcb'
import MasterCardIcon from './assets/mastercard'
import UnionPayIcon from './assets/unionpay'
import VisaIcon from './assets/visa'

export const USD_CURRENCY = 'USD'
export const REQUEST_BUTTON_APPLEPAY = 'apple-pay'
export const REQUEST_BUTTON_GOOGLEPAY = 'google-pay'
export const REQUEST_BUTTON_OTHER = 'other'
export const PAY_FOR_FREE = 'free'
export const PAY_WITH_OPTION = 'option'
export const PAY_WITH_SOURCE = 'source'
export const PAY_WITH_DIRECT_BILL = 'direct_bill'
export const PAY_WITH_INTENT = 'intent'
export const ASYNC_PAYMENT_METHOD = 'async'
export const EXISTING_OPTION_ID = -1
export const PROVIDER_OPTION_ID = -2
export const SUPPORTED_PROVIDERS = {
  Visa: VisaIcon,
  MasterCard: MasterCardIcon,
  'American Express': AmexIcon,
  'Diners Club': DinnerIcon,
  Discover: DiscoverIcon,
  JCB: JCBIcon,
  Unionpay: UnionPayIcon,
}

export const CARD_BRAND_MAP = {
  visa: 'Visa',
  mastercard: 'Mastercard',
  amex: 'American Express',
  discover: 'Discover',
  diners: 'Diners Club',
  jcb: 'JCB',
  unionpay: 'UnionPay',
  unknown: undefined,
}

export const DEVELOPMENT_STRIPE_CONFIGS = [
  {
    default: true,
    currencies: [],
    origin: 'USD',
    country: 'US',
    apiKey: 'pk_test_qPRtd6kXTYX6zW1dbSwDi9oZ',
  },
]

export const PRODUCTION_STRIPE_CONFIGS = [
  {
    default: true,
    currencies: ['USD'],
    origin: 'USD',
    country: 'US',
    apiKey: 'pk_live_TR09fuN4JRV9kivCy9DGmaXK',
  },
  // TODO: Disabled until we support PSD2
  // {
  //   currencies: ['EUR', 'GBP'],
  //   origin: 'EUR',
  //   country: 'IE',
  //   apiKey: 'pk_live_ieitqyidJnvl3o6cOl9Cw8lL',
  // },
]
